import { Link as RouterLink } from "react-router-dom";
import {
    Grid,
    Card,
    CardContent,
    CardHeader,
    CardActions,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Button,
    Box,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import StarIcon from "@mui/icons-material/Star";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import DiamondIcon from '@mui/icons-material/Diamond';

import PageContainer from "../components/page-container/PageContainer";

const tiers = [
    {
        id: "basic",
        title: "Basic (Beta)",
        price: 0,//499,
        description: "For individuals getting started",
        icon: StarIcon,
        color: '#CD7F32',
        features: [
            "1 User",
            "Up to 3 projects",
            "Email support",
        ],
        active: false
    },
    {
        id: "pro",
        title: "Pro",
        price: 0,//699,
        description: "For growing teams and freelancers",
        icon: WorkspacePremiumIcon,
        color: '#C0C0C0',
        features: [
            "1 User",
            "Unlimited projects",
            "Priority email support",
            "Access to pro features",
        ],
        active: false
    },
    {
        id: "enterprise",
        title: "Enterprise",
        price: 0,//899,
        description: "For large organisations with advanced needs",
        icon: DiamondIcon,
        color: "#FFD700",
        features: [
            "Up to 5 Users",
            "Unlimited projects",
            "Access to all features",
            "Dedicated account manager",
            "Premium support 24/7",
        ],
        active: false
    },
];

const PricingPage = () => {
    return (
        <PageContainer>
            <Typography variant="h3" align="center" gutterBottom sx={{ mt: 8 }}>
                Choose Your Plan
            </Typography>
            <Typography variant="subtitle1" align="center" sx={{ mb: 6 }}>
                Simple, transparent pricing designed for the South African market (prices include VAT)
            </Typography>

            <Grid container spacing={4} justifyContent="center">
                {tiers.map(({ id, title, price, description, icon: Icon, color, features, active }) => (
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} key={id}>
                        <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                            <CardHeader
                                avatar={<Icon fontSize="large" sx={{ color: color }} />}
                                title={<Typography variant="h5">{title}</Typography>}
                                subheader={description}
                                sx={{ textAlign: "left" }}
                            />
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Box sx={{ textAlign: "center", mb: 2 }}>
                                    <Typography variant="h4" component="span">
                                        R{price}
                                    </Typography>
                                    <Typography component="span" variant="h6" color="text.secondary">
                                        /mo
                                    </Typography>
                                </Box>
                                <List>
                                    {features.map((feature) => (
                                        <ListItem key={feature} disableGutters>
                                            <ListItemIcon>
                                                <CheckIcon color="success" />
                                            </ListItemIcon>
                                            <ListItemText primary={feature} />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                            <CardActions sx={{ justifyContent: "center", pb: 3 }}>
                                {active ?
                                    <Button
                                        component={RouterLink}
                                        to={`/signup?tier=${id}`}
                                        variant={id === "pro" ? "contained" : "outlined"}
                                        size="large"
                                    >
                                        Get Started
                                    </Button>
                                    :
                                    "Coming soon"
                                }
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            <Typography variant="caption" display="block" align="center" sx={{ mt: 4, color: "text.secondary" }}>
                Need a custom plan? <RouterLink to="/contact-us">Contact us</RouterLink>
            </Typography>
        </PageContainer>
    );
}

export default PricingPage;